import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { FrameFileDefaultLinkContainerModel } from '../../../../../../models';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({ providedIn: 'root' })

export class FrameFileDefaultLinkService extends BaseApiPublicLoginTemplateService<FrameFileDefaultLinkContainerModel, FrameFileDefaultLinkContainerModel, FrameFileDefaultLinkContainerModel> {
    endpointSubPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'frame/file-default-link-hdrs';
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + this.endpointSubPath + '/backoffice-ep';
        this.endpoint_path = this.endpointSubPath + '/backoffice-ep';
        this.endpoint_path_public_url = this.endpointSubPath + '/public-ep';
        this.httpClient = http;
    }
}